export default {
  methods: {
    createPhoneLink({ phone = this.$t('ulekareContacts.phone'), classAttrib = '' } = {}) {
      return `<a itemprop="telephone" href="tel:${this.linkerizePhone(
        phone
      )}" class="${classAttrib}">${phone}</a>`;
    },
    linkerizePhone(phone = this.$t('ulekareContacts.phone')) {
      return phone.replace(/\s/g, '').replace(/&nbsp;/g, '');
    }
  }
};
